import { useCallback, useState } from 'react';
import Iconify from 'src/components/iconify';
import '../../styles/dashboard.scss';
import { useSettingsContext } from 'src/components/settings';
// import UploadImageComponent from 'src/custom_components/Froms/imageContentUpload';
import { Container, Box, Table, TableBody, TableContainer, Tooltip, Card } from '@mui/material';
import {
  TableEmptyRows,
  TableHeadCustom,
  TableNoData,
  TablePaginationCustom,
  TableSelectedAction,
  emptyRows,
  getComparator,
  useTable,
} from 'src/components/table';
import { _roles } from 'src/_mock';
import UserTableRow from 'src/custom_components/Table/customer-table-row';
import { isEqual } from 'lodash';
import { toast } from 'react-toastify';
import { useAuthActions, useAuthData } from 'src/context/Auth/AuthContext';
import { IconButton } from 'yet-another-react-lightbox';
import { useBoolean } from 'src/hooks/use-boolean';
import Scrollbar from 'src/components/scrollbar';
import { applyFilter } from 'src/custom_components/Table/helper/applyFilter';
import { TABLE_HEADAdmin, tableNamesAdmin } from './view/data';
import UserTableToolbar from '../customer-address-details/customer-table-toolbar';
import { defaultFilters } from '../customer/view/data';
import UserTableFiltersResult from '../customer-address-details/customer-table-filters-result';

export default function Admins() {
  const table = useTable();
  const confirm = useBoolean();
  const { admins } = useAuthData();
  const { clearAdmin, getAllAdmins } = useAuthActions();
  // eslint-disable-next-line
  const [aRow, setARow] = useState({});
  const settings = useSettingsContext();

  const tableData = admins;

  const [filters, setFilters] = useState(defaultFilters);

  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator(table.order, table.orderBy),
    filters,
  });

  const canReset = !isEqual(defaultFilters, filters);

  const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

  const denseHeight = table.dense ? 52 : 72;

  const handleFilters = useCallback(
    (name, value) => {
      table.onResetPage();
      setFilters((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [table]
  );

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
    setARow({});
  };
  const handleDeleteRow = async (e, id) => {
    try {
      const response = await clearAdmin(id);
      if (response) {
        await getAllAdmins();
        toast.success('Admin cleared successfully');
      }
    } catch (error) {
      toast.error('Failed to clear admin');
    }
  };

  return (
    <div>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <Box sx={{ mt: 5 }}>
          Admin User Table
          <Card sx={{ mt: 2 }}>
            <UserTableToolbar
              filters={filters}
              onFilters={handleFilters}
              //
              roleOptions={_roles}
            />

            {canReset && (
              <UserTableFiltersResult
                filters={filters}
                onFilters={handleFilters}
                //
                // onResetFilters={handleResetFilters}
                //
                results={dataFiltered.length}
                sx={{ p: 2.5, pt: 0 }}
              />
            )}

            <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
              <TableSelectedAction
                dense={table.dense}
                numSelected={table.selected.length}
                rowCount={tableData.length}
                onSelectAllRows={(checked) =>
                  table.onSelectAllRows(
                    checked,
                    tableData.map((row) => row.id)
                  )
                }
                action={
                  <Tooltip title="Delete">
                    <IconButton color="primary" onClick={confirm.onTrue}>
                      <Iconify icon="solar:trash-bin-trash-bold" />
                    </IconButton>
                  </Tooltip>
                }
              />

              <Scrollbar>
                <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 960 }}>
                  <TableHeadCustom
                    order={table.order}
                    orderBy={table.orderBy}
                    headLabel={TABLE_HEADAdmin}
                    rowCount={tableData.length}
                    numSelected={table.selected.length}
                    onSort={table.onSort}
                    onSelectAllRows={(checked) =>
                      table.onSelectAllRows(
                        checked,
                        tableData.map((row) => row.id)
                      )
                    }
                  />

                  <TableBody>
                    {dataFiltered
                      .slice(
                        table.page * table.rowsPerPage,
                        table.page * table.rowsPerPage + table.rowsPerPage
                      )
                      .map((row) => (
                        <UserTableRow
                          key={row.id}
                          row={row}
                          selected={table.selected.includes(row.id)}
                          onSelectRow={() => table.onSelectRow(row.id)}
                          onDeleteRow={(e) => handleDeleteRow(e, row.id)}
                          // onEditRow={() => handleEditRow(row.id)}
                          handleDrawerToggle={handleDrawerToggle}
                          setARow={setARow}
                          tableNames={tableNamesAdmin}
                        />
                      ))}

                    <TableEmptyRows
                      height={denseHeight}
                      emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                    />

                    <TableNoData notFound={notFound} />
                  </TableBody>
                </Table>
              </Scrollbar>
            </TableContainer>

            <TablePaginationCustom
              count={dataFiltered.length}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
              //
              dense={table.dense}
              onChangeDense={table.onChangeDense}
            />
          </Card>
        </Box>
        {/* </Box> */}
      </Container>
    </div>
  );
}
